// src/context/LogoContext.js
import React, { createContext, useContext, useState, useMemo } from "react";

const LogoContext = createContext();

export const LogoProvider = ({ children }) => {
  const [logo, setLogo] = useState(null);            // image URL (string) or null
  const [hospitalName, setHospitalName] = useState(""); // fallback text

  // computed finalLogo - useMemo so it's stable
  const finalLogo = useMemo(() => {
    if (logo && typeof logo === "string" && logo.trim() !== "") {
      return { isImage: true, value: logo };
    }
    // fallback: take first two words and return as newline-separated string
    const stacked = (hospitalName || "")
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .join("\n") || ""; // may be empty string
    return { isImage: false, value: stacked };
  }, [logo, hospitalName]);

  return (
    <LogoContext.Provider
      value={{
        logo,
        setLogo,
        hospitalName,
        setHospitalName,
        finalLogo,
      }}
    >
      {children}
    </LogoContext.Provider>
  );
};

export const useLogo = () => useContext(LogoContext);
